@if (format !== MangaFormat.UNKNOWN) {
  @if (useTitle) {
    <i class="{{format | mangaFormatIcon}}" aria-hidden="true" title="{{format | mangaFormat}}"></i>
  } @else {
    <i class="{{format | mangaFormatIcon}}" aria-hidden="true" ngbTooltip="{{format | mangaFormat}}"></i>
  }
  <ng-content></ng-content>
}
